<template>
  <div>
    <v-card class="mb-4" max-width="400">
      <v-list-item three-line class="pl-0">
        <v-list-item-content>
          <v-list-item-title class="subtitle-1">{{
            poi.name
          }}</v-list-item-title>
          <v-list-item-subtitle class="subtitle-2"
            >Type: {{ getPoiTypeName(poi.poiTypeId) }}</v-list-item-subtitle
          >
          <v-list-item-subtitle
            >Parent: {{ poisParentName }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-card-actions>
        <!-- <v-btn icon top right absolute v-on:click="removePoi()">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>-->
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    poi: {
      type: Object,
      required: true,
      default: function() {
        return {}
      }
    },
    gridView: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    }
  },
  methods: {
    getPoiTypeName(poiTypeId) {
      let type
      this.$store.state.PoiStore.poiTypes.forEach(element => {
        if (element.typeId == poiTypeId) type = element
      })
      return type ? type.name : ''
    },
    poiClick: function(id) {
      //this.$router.push('/projects/'+projectId)
    },
    removePoi: function() {
      this.$store.dispatch('MenuItemsStore/removePoiForMenuItem', {
        menuItemId: this.$route.params.menuItemId,
        poiId: this.poi.id
      })
    }
  },
  data: function() {
    return {
      poisParentName: ''
    }
  },
  created: function() {
    this.$store.dispatch('PoiStore/getPoisParent', this.poi.id).then(parent => {
      this.poisParentName = parent.data.name
    })
  }
}
</script>

<style scoped></style>
